import { Box, makeStyles, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    ContainerMui,
    Variant,
    Typography,
    Police,
    ColorHex,
    BorderRadiusMui
} from '../../../../styles';
import { TexteAvecInfoBulle } from '../../../../components';
import { FrequenceDureeTerme } from '../../../../hooks';

interface IInfoEconomieProps {
    value: number;
    valeurDureeTerme: number;
    frequenceDureeTerme: FrequenceDureeTerme;
    onTooltipActive: () => void;
}

const useStyles = makeStyles(() => ({
    textInfoEconomie: {
        fontSize: '20px !important'
    }
}));

export const InfoEconomie: React.FC<IInfoEconomieProps> = ({
    value,
    valeurDureeTerme,
    frequenceDureeTerme,
    onTooltipActive
}) => {
    const [t] = useTranslation('InfoEconomie');
    const isMobile = useMediaQuery('(max-width:640px)');

    const classes = useStyles();

    const getValue = () => (value > 0 ? value : 0);

    const getLabelInfobulle = (): string => {
        return (
            t('economie_1') +
            t(
                'Date:' +
                    (frequenceDureeTerme === FrequenceDureeTerme.MOIS
                        ? 'monthsOffer'
                        : 'yearsOffer'),
                {
                    value: valeurDureeTerme
                }
            ) +
            t('economie_2')
        );
    };

    return (
        <ContainerMui
            backgroundColor={ColorHex.lightConfirmation2}
            borderRadius={BorderRadiusMui.sm}
            maxWidth={isMobile ? '100%' : '71%'}
        >
            <TexteAvecInfoBulle
                isLabelEtIconeCentres={!isMobile}
                label={getLabelInfobulle()}
                labelInfoBulle={
                    <>
                        {t('tooltipEconomie_1')}
                        <br />
                        {t('tooltipEconomie_2')}
                    </>
                }
                isSmallerLabelInfobulle={isMobile}
                labelColor={ColorHex.darkPrimary}
                labelHorsEcranInfoBulle={getLabelInfobulle()}
                iconColorCustom={ColorHex.lightGraphite5}
                onToolTipActive={onTooltipActive}
            />

            <Box display="flex" justifyContent="center" flexWrap="nowrap">
                <Box paddingRight={isMobile ? '0.5rem' : '1rem'}>
                    <Typography
                        variant={Variant.p}
                        police={Police.bold}
                        color={ColorHex.darkPrimary}
                        className={classes.textInfoEconomie}
                    >
                        {t('Number:currency', {
                            value: getValue()
                        })}
                    </Typography>
                </Box>
            </Box>
        </ContainerMui>
    );
};
